import React, { useState, useRef, useEffect } from 'react'
import Image from '../atoms/Image'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import SbEditable from 'storyblok-react'

import Link from '../atoms/Link'
import Countdown from '../atoms/Countdown'

gsap.registerPlugin(ScrollTrigger)

const HeroCountdownBlock = ({ block }) => {
  const refHeroScroll = useRef(null)

  useEffect(() => {
    gsap.from(refHeroScroll.current, {
      //duration: 1,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: refHeroScroll.current,
        toggleActions: 'play none none none',
        start: 'top -40px',
        end: 99999,
        toggleClass: 'scrolled-state',
      },
    })
  }, [])

  let hasImage =
    block.image?.filename?.length > 0 ||
    block.image?.src?.length > 0 ||
    block.image?.length > 0
  let hasVideo = block.video?.filename?.length > 0

  return (
    <SbEditable content={block}>
      <section ref={refHeroScroll} className="hero-countdown-block">
        <article className="hero-countdown-block-content">
          {block.headline?.length > 0 && (
            <h1 className="hero-countdown-block-headline">{block.headline}</h1>
          )}
          <div className="hero-countdown-block-image-container">
            <div className="hero-countdown-block-image">
              <div className="hero-countdown-block-image-overlay" />
              <div data-rellax={true} data-rellax-speed={-5}>
                {hasImage == true && (
                  <Image
                    className="img-fluid"
                    image={block.image}
                    alt={block.alt}
                    imageWidth="1397"
                    imageHeight="786"
                  />
                )}
                {hasVideo === true && (
                  <video
                    className="vid-fluid"
                    src={block.video.filename}
                    autoPlay={true}
                    loop={true}
                    muted={true}
                  />
                )}
              </div>
            </div>
          </div>
          <Link
            link={block.link}
            className="hero-countdown-block-content-overlay"
          >
            <div className="hero-countdown-block-content-container">
              <Countdown countdownDate={block.countdown_date} />
            </div>
          </Link>
        </article>
      </section>
    </SbEditable>
  )
}

export default HeroCountdownBlock
